import {
    getRemoteConfig,
    fetchAndActivate,
    getAll,
} from 'firebase/remote-config';

import { firebaseApp } from '../firebase';
import { RemoteConfig } from './config-type';
import defaultConfig from './default.json';

const IS_DEV = process.env.NODE_ENV === 'development';

export const fetchRemoteConfig = async (): Promise<RemoteConfig> => {
    const remoteConfig = getRemoteConfig(firebaseApp);
    remoteConfig.settings.minimumFetchIntervalMillis = IS_DEV
        ? 0
        : 60 * 60 * 1000;
    remoteConfig.defaultConfig = defaultConfig as unknown as Record<
        string,
        string
    >;

    await fetchAndActivate(remoteConfig);
    const all = getAll(remoteConfig);

    const config: Record<string, any> = {};
    for (const [key, value] of Object.entries(all)) {
        try {
            config[key] = JSON.parse(value.asString());
        } catch {
            config[key] = value.asString();
        }
    }

    return config as RemoteConfig;
};
